import { __assign, __extends } from "tslib";
import * as React from 'react';
import { infoMark, errorMark } from '../marketing-input/icons';
import { Popover, Icon, DeprecatedSelect } from '@wix/answers-ui-libby';
import { checkIfMobile } from '../utils';
import { RenderHtml } from '../../utils';
import { classNames, noop } from '@wix/answers-lib';
var DEBOUNCE_TIMEOUT = 200;
var MarketingSelect = /** @class */ (function (_super) {
    __extends(MarketingSelect, _super);
    function MarketingSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tooltipDebounce = null;
        _this.inputRef = null;
        _this.state = {
            isFocused: false,
            showTooltip: false,
            isMobile: checkIfMobile()
        };
        _this.onResize = function () {
            if (!_this.state.isMobile && checkIfMobile()) {
                _this.setState({ isMobile: true });
            }
            else if (_this.state.isMobile && !checkIfMobile()) {
                _this.setState({ isMobile: false });
            }
        };
        _this.focusInput = function () {
            if (!!_this.inputRef) {
                _this.inputRef.focus();
            }
        };
        _this.onFocus = function () {
            if (_this.props.onFocus) {
                _this.props.onFocus();
            }
        };
        _this.onBlur = function () {
            if (_this.props.onBlur && _this.props.value) {
                _this.props.onBlur();
            }
            _this.setState({ isFocused: false });
        };
        _this.onChange = function (option) {
            _this.onBlur();
            _this.props.onChange(option);
        };
        _this.onMobileChange = function (e) {
            var option = _this.props.options.filter(function (i) { return i.value === e.target.value; })[0];
            _this.onChange(option);
        };
        _this.showTooltip = function () {
            if (_this.tooltipDebounce) {
                clearTimeout(_this.tooltipDebounce);
            }
            _this.setState({ showTooltip: true });
        };
        _this.hideTooltip = function () {
            _this.tooltipDebounce = setTimeout(function () { return _this.setState({ showTooltip: false }); }, DEBOUNCE_TIMEOUT);
        };
        _this.maybeRenderInfoTooltip = function () {
            var props = _this.props;
            var tooltipBody = props.infoText && !props.error ? (React.createElement("span", { className: 'tooltip-body', onMouseOver: _this.showTooltip, onMouseOut: _this.hideTooltip },
                React.createElement(RenderHtml, { html: props.infoText }))) : null;
            var maybeShowTooltip = props.infoText && !props.error ? (React.createElement("span", { className: classNames('tooltip-wrapper', { 'with-error': !!props.error }), onMouseOver: _this.showTooltip, onMouseOut: _this.hideTooltip },
                React.createElement(Popover, { className: 'info-tooltip', isOpen: _this.state.showTooltip, preferPlace: 'right', body: tooltipBody, onOuterAction: _this.hideTooltip },
                    React.createElement(Icon, { icon: infoMark })))) : null;
            return maybeShowTooltip;
        };
        _this.renderMobileSelect = function () {
            var props = _this.props;
            var mobileOptions = props.options.map(function (option, idx) {
                return React.createElement("option", { key: idx, value: option.value }, option.label);
            });
            return (React.createElement("select", { value: props.value ? props.value.value : '', onChange: _this.onMobileChange },
                React.createElement("option", { value: '', selected: true, disabled: true, hidden: true }),
                mobileOptions));
        };
        return _this;
    }
    MarketingSelect.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.onResize);
    };
    MarketingSelect.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onResize);
    };
    MarketingSelect.prototype.render = function () {
        var props = this.props;
        var _a = this.state, isFocused = _a.isFocused, isMobile = _a.isMobile;
        var showLabel = isFocused || !!props.value;
        var inputClasses = classNames('marketing-select', props.className, { 'show-label': showLabel, 'has-error': !!props.error, focused: isFocused, 'is-mobile': isMobile });
        var inputMarker = props.infoText && !props.error ? this.maybeRenderInfoTooltip() : props.error ? React.createElement(Icon, { className: 'error-icon', icon: errorMark }) : null;
        var labelComp = (React.createElement("label", { onClick: this.focusInput },
            props.label,
            !isMobile ? React.createElement("span", { className: 'select-arrow' }) : null));
        var selectProps = {
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            value: props.value,
            options: props.options,
            onChange: this.onChange,
            placeholder: '',
            searchable: false
        };
        var selectComp = isMobile ? this.renderMobileSelect() : React.createElement(DeprecatedSelect, __assign({}, selectProps));
        var errorBody = props.error ? React.createElement("span", { className: 'error-body' },
            React.createElement(RenderHtml, { html: props.error || '' })) : '';
        var InputWithErrorTooltip = !isMobile ? (React.createElement(Popover, { className: 'error-tooltip', body: errorBody, isOpen: !!props.error && !isFocused, preferPlace: props.errorTooltipPosition || 'left', onOuterAction: noop }, selectComp)) : (React.createElement("span", { className: 'mobile-select-wrapper' },
            selectComp,
            isMobile ? React.createElement("span", { className: 'select-arrow' }) : null,
            errorBody));
        var fixedPlaceholder = this.props.fixedPlaceholder ?
            React.createElement("span", { className: 'fixed-placeholder', onClick: this.focusInput }, this.props.fixedPlaceholder) : null;
        return (React.createElement("div", { className: inputClasses, onClick: this.focusInput },
            labelComp,
            InputWithErrorTooltip,
            fixedPlaceholder,
            inputMarker,
            React.createElement("span", { className: 'focus-line' })));
    };
    return MarketingSelect;
}(React.PureComponent));
export { MarketingSelect };
//# sourceMappingURL=marketing-select.js.map